import { Link } from 'react-router';
import { ArrowRight } from '@phosphor-icons/react';
import dashboardImage from '../../assets/chatserve/dashboard.webp';
import '../LandingPage.css';

// Above-the-fold content is not wrapped in .reveal: it must paint at once.
function HeroSection() {
  return (
    <section className="hero-section" aria-labelledby="hero-title">
      <div className="hero-inner">
        <div className="hero-content">
          <h1 id="hero-title" className="hero-title">
            Web apps built around
            <br className="hero-break" /> how your business works
          </h1>

          <p className="hero-subtitle">
            EFSoft has designed and built software for more than 20 years. We
            also build and run ChatServe, our own ordering and fiscal receipt
            system for restaurants and bars in Romania and Spain.
          </p>

          <div className="hero-actions">
            <Link to="/#contact" className="btn btn--light">
              Start a project
              <ArrowRight size={18} weight="bold" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <figure className="hero-visual">
          <div className="hero-visual-frame">
            <img
              src={dashboardImage}
              alt="ChatServe analytics dashboard with order totals, revenue and an orders trend chart"
              width={2880}
              height={1800}
              fetchPriority="high"
              decoding="async"
            />
          </div>
          <figcaption className="hero-visual-caption">
            ChatServe, built and run by EFSoft
          </figcaption>
        </figure>
      </div>
    </section>
  );
}

export default HeroSection;
